import {
  recover,
  resetSubmitState,
  resetErrorMessage,
} from "../../../modules/recovery";

const initialState = {};

export const passwordRecoveryReducer = (state = initialState, action) => {
  return state;
};

export const mapStateToProps = (state) => {
  return {
    ...state.recoveryReducer,
    loginUsername: state.loginReducer.loginUsername,
  };
};

export const mapDispatchToProps = {
  recover,
  resetSubmitState,
  resetErrorMessage,
};
